<app-dialog-title
  class="g-flex-column__item-fixed"
  title="{{ 'forge-result-dialog.title' | translate }}&nbsp;{{
    (data.isSuccess ? 'forge-result-dialog.successful' : 'forge-result-dialog.unsuccessful') | translate
  }}"
  (closeDialog)="close()">
</app-dialog-title>

<div class="container g-flex-column g-flex--align-center">
  <div class="title__text">
    {{
      (data.isSuccess
        ? 'forge-result-dialog.successful-text'
        : !data.hasStabilizer
          ? 'forge-result-dialog.unsuccessful-text'
          : 'forge-result-dialog.unsuccessful-stabilizer-text'
      ) | translate
    }}
  </div>

  @if (newItem && data.isSuccess) {
    <app-item-card
      class="item"
      [item]="newItem">
    </app-item-card>
  } @else {
    @if (!data.isSuccess) {
      <img
        class="unsuccessful-image"
        src="/assets/images/ui/icons/other/forge-destroy.png"
        alt="no image" />
    }
  }

  <button
    class="btn-apply app-btn-blue-3"
    appButtonClick
    (hostClick)="close()">
    {{ 'forge-result-dialog.buttons.close' | translate }}
  </button>
</div>
